import ArrivalDepartureFilter from '../modules/search/store/ArrivalDepartureFilter';
import BedroomsFilter from '../modules/search/store/BedroomsFilter';
import type HouseSearchFilters from '../modules/search/store/HouseSearchFilters';
import TravelPartyFilter from '../modules/search/store/TravelPartyFilter';
import { getCategoryName } from '../util/dataLayer';
import { FeatureToggle, isFeatureEnabled } from '../util/featureToggle';
import GoogleAnalyticsEvents from './GoogleAnalyticsEvents';

class SqueezelyEvents {
    public trackSearchForm(
        filters: HouseSearchFilters,
        initialData: StandardObjectInterface
    ): void {
        if (isFeatureEnabled(FeatureToggle.GOOGLE_TAG_MANAGER)) {
            return;
        }

        const dateFilter = filters.get(ArrivalDepartureFilter.NAME) as ArrivalDepartureFilter;
        const travelPartyFilter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
        const bedroomsFilter = filters.get(BedroomsFilter.NAME) as BedroomsFilter;

        const data: GoogleAnalytics4ListerEvent = {
            CategoryName: getCategoryName(),
            custom_lastcountry: initialData.country_name || '',
            custom_lastregion: initialData.region_name || '',
            custom_lastcity: initialData.place_name || '',
            checkin_date: dateFilter.parameters.arrivalDate || '',
            checkout_date: dateFilter.parameters.departureDate || '',
            custom_adults: travelPartyFilter.parameters.adults || '',
            custom_children: travelPartyFilter.parameters.children || '',
            custom_babies: travelPartyFilter.parameters.babies || '',
            custom_pets: travelPartyFilter.parameters.pets || '',
            custom_bedrooms: bedroomsFilter.parameters.bedrooms || '',
            custom_theme: filters.get('themes')?.parameters.themes || '',
            custom_service: filters.get('facilities')?.parameters.facilities || '',
            custom_type: filters.get('types')?.parameters.types || '',
            custom_location:
                filters.get('locationDescriptions')?.parameters.locationDescriptions || '',
            custom_durability: filters.get('sustainability')?.parameters.sustainability || '',
            custom_reviews: filters.get('houseRating')?.parameters.houseRating || '',
            custom_nature: filters.get('natureRating')?.parameters.natureRating || '',
            currency: 'EUR'
        };

        GoogleAnalyticsEvents.trackEvent<GoogleAnalytics4ListerEvent>('Lister', data);
    }
}

export { SqueezelyEvents };
export default new SqueezelyEvents();
